import React, { useState } from 'react';
import { Button } from '../UI/Button';
interface PaystackPaymentProps {
  amount: number; // in naira
  email: string;
  name?: string;
  phone?: string;
  onSuccess?: (reference: string) => void;
  onClose?: () => void;
}
export const PaystackPayment: React.FC<PaystackPaymentProps> = ({
  amount,
  email,
  name,
  phone,
  onSuccess,
  onClose
}) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const initializePayment = () => {
    setIsProcessing(true);
    // @ts-ignore - PaystackPop is loaded via script
    const handler = window.PaystackPop?.setup({
      key: 'pk_live_c2f71547b29d95243a012d9ef2f8e03485d942e7',
      email,
      amount: amount * 100,
      name: name || 'The Networking Salon',
      phone,
      callback: (response: any) => {
        setIsProcessing(false);
        if (onSuccess) onSuccess(response.reference);
      },
      onClose: () => {
        setIsProcessing(false);
        if (onClose) onClose();
      }
    });
    handler.openIframe();
  };
  return <div className="w-full" data-id="element-930">
      <Button onClick={initializePayment} disabled={isProcessing} className="w-full" data-id="element-931">
        {isProcessing ? 'Processing...' : `Pay ₦${amount.toLocaleString()}`}
      </Button>
    </div>;
};